import axios from 'axios';

export function tariffFromApi(tariff) {
  return {
    level: Number(tariff && tariff.level) || 0,
    name: (tariff && tariff.name) || '',
    code: (tariff && tariff.code) || '',
    endsAt: (tariff && tariff.endsAt) || '',
    state: (tariff && tariff.state) || 'none',
  };
}

function sameTariff(current, next) {
  return current.level === next.level
    && current.name === next.name
    && current.code === next.code
    && current.endsAt === next.endsAt
    && current.state === next.state;
}

export function installTariffSync(store) {
  axios.interceptors.response.use((response) => {
    const incoming = response && response.data && response.data.viewerTariff;
    if (!incoming || typeof incoming !== 'object') return response;

    const next = tariffFromApi(incoming);
    if (!sameTariff(store.state.tariff, next)) {
      store.setState({ tariff: next });
    }

    return response;
  });
}
